var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"renzh"},[_c('div',{staticClass:"title"},[_c('img',{attrs:{"src":require("../../assets/imgs/qiyeziliao/ziliao3.png"),"alt":""}}),_c('span',[_vm._v("企业资料认证审核中，请耐心等待...")])]),_c('img',{attrs:{"src":require("../../assets/imgs/qiyeziliao/ziliao2.png"),"alt":""}})])
}]

export { render, staticRenderFns }